module.exports = __webpack_public_path__ + "static/media/country_cn.4baca173.webp";